import { configureStore } from "@reduxjs/toolkit";
import { cryptoApi } from "../services/cryptoApi";
import { rapidCryptoApi } from "../services/RapidCryptoApi";
import { cryptoNewsApi } from "../services/cryptoNewsApi";
import loadingSlice from "./loading-slice";
export default configureStore({
  reducer: {
    [cryptoApi.reducerPath]: cryptoApi.reducer,
    [rapidCryptoApi.reducerPath]: rapidCryptoApi.reducer,
    [cryptoNewsApi.reducerPath]: cryptoNewsApi.reducer,
    loader: loadingSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      cryptoApi.middleware,
      rapidCryptoApi.middleware,
      cryptoNewsApi.middleware
    ]),
});
